var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Popup',_vm._g(_vm._b({},'Popup',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"authenPopupBox"},[_c('div',{staticClass:"authenPopupTip"},[_vm._v("您有待完成的认证信息，快去认证吧！")]),_c('div',{staticClass:"authenPopupText"},[_vm._v("为了便于您快速完成进件申请，请先完成实名认证后再继续申请。")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }